import { isAxiosError } from 'axios';

import { isUnauthenticatedError } from './UnauthenticatedError';

const RETRYABLE_STATUSES = new Set([408, 429, 500, 502, 503, 504]);

const MAX_RETRY_ATTEMPTS = 5;
const MAX_RETRY_DELAY_MS = 2000;

export const isServerOutageError = (error: unknown): boolean => {
    const isNotServerOutage =
        isUnauthenticatedError(error) || !isAxiosError(error) || error.code === 'ERR_CANCELED';
    if (isNotServerOutage) return false;
    if (!error.response) return true;

    return RETRYABLE_STATUSES.has(error.response.status);
};

export const retryServerOutages = (failureCount: number, error: unknown): boolean =>
    failureCount < MAX_RETRY_ATTEMPTS && isServerOutageError(error);

export const serverOutageRetryDelay = (failureCount: number): number =>
    Math.min(1000 * 2 ** failureCount, MAX_RETRY_DELAY_MS);
